import React from 'react';

export const CronScheduler: React.FC = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold">Cron Scheduler Module</h1>
      <p>This module is under construction.</p>
    </div>
  );
};
